import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/station/co2.svg'
import _imports_1 from '@/assets/station/tree.svg'
import _imports_2 from '@/assets/station/tan.svg'


const _withScopeId = n => (_pushScopeId("data-v-660bc737"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "光伏", -1))
const _hoisted_3 = { class: "card-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "今天"),
  /*#__PURE__*/_createElementVNode("div", null, "总")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "收益"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" $"),
    /*#__PURE__*/_createElementVNode("span", { class: "card-value" }, /*#__PURE__*/_toDisplayString('--'))
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" $"),
    /*#__PURE__*/_createElementVNode("span", { class: "card-value" }, /*#__PURE__*/_toDisplayString('--'))
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发电量", -1))
const _hoisted_7 = { class: "card-value" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("kWh ")
const _hoisted_9 = { class: "card-value" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("kWh ")
const _hoisted_11 = { class: "card" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "负载", -1))
const _hoisted_13 = { class: "card-content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "今天", -1))
const _hoisted_15 = { class: "card-value" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("kWh ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总", -1))
const _hoisted_18 = { class: "card-value" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("kWh ")
const _hoisted_20 = { class: "card" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "电池", -1))
const _hoisted_22 = { class: "card-content" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "今天"),
  /*#__PURE__*/_createElementVNode("div", null, "总")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "充电量", -1))
const _hoisted_25 = { class: "card-value" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("kWh ")
const _hoisted_27 = { class: "card-value" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("kWh ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "放电量", -1))
const _hoisted_30 = { class: "card-value" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("kWh ")
const _hoisted_32 = { class: "card-value" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("kWh ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "能量概览", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "station-info-title" }, "站点信息", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电站地址：", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所有人：", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电站ID：", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电站容量：", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "能量分析", -1))
const _hoisted_41 = { class: "chart-selector" }
const _hoisted_42 = { style: {"height":"500px"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, "节能减排", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-flex title" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "title-icon" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "co2.svg"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", null, "CO2 减排量(kg)")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "title-icon" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: "tree.svg"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", null, "等效植树量(棵)")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "title-icon" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        alt: "tree.svg"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", null, "节约标准煤 kg")
  ])
], -1))
const _hoisted_45 = { class: "item-flex bg-col" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当日", -1))
const _hoisted_47 = { class: "value" }
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "value" }
const _hoisted_50 = { class: "item-flex bg-col" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "累计", -1))
const _hoisted_52 = { class: "value" }
const _hoisted_53 = { class: "value" }
const _hoisted_54 = { class: "value" }

import EnergyFlowCanvas from '@/components/EnergyFlowCanvas.vue'
import { StatisticsTimeGrain } from '@/types/types'
import { useStationData } from '@/views/DataV/Station/useStationData'
import { onMounted, ref, watch } from 'vue'
import EnergyAnalysisChartLine from '@/views/DataV/Photovoltaic/components/EnergyAnalysisChartLine.vue'
import { EssEnergyChart } from '@/types/common/station'
import { GetEssEnergyAnalysisStats } from '@/api/evses'
import { EssEnergyGrowthTrendChartData } from '@/views/DataV/Photovoltaic/types'

export default /*#__PURE__*/_defineComponent({
  props: {
  opeartorID: {
    type: String,
    default: '',
  },
  stationID: {
    type: String,
    default: '',
  },
  showDownloadBtn: {
    type: Boolean,
    default: false,
  },
  stationInfo: {
    type: Object,
    default: () => {
      return {}
    },
  },
},
  setup(__props) {

const props = __props


const { stationInfoData, essEnergyConversionStats, essStationFlowData, startIntervalFlowData } =
  useStationData(props.stationID)

// 统计纬度
const energyAnalysisCycle = ref<StatisticsTimeGrain>(StatisticsTimeGrain.STD_DAY)
const cycleList = [
  { label: '日', value: StatisticsTimeGrain.STD_DAY },
  { label: '周', value: StatisticsTimeGrain.STD_WEEK },
  { label: '月', value: StatisticsTimeGrain.STD_MONTH },
  { label: '年', value: StatisticsTimeGrain.STD_YEAR },
  { label: '总计', value: StatisticsTimeGrain.STD_TOTAL },
]

const essEnergyAnalysisStatsChartData = ref<EssEnergyGrowthTrendChartData>({})

const fetchEssEnergyAnalysisStats = () => {
  GetEssEnergyAnalysisStats({
    grain: energyAnalysisCycle.value,
  }).then((res: { list: EssEnergyChart[] }) => {
    essEnergyAnalysisStatsChartData.value = {
      xAxisData: res.list.map((item) => item.time),
      seriesData: [
        {
          name: '充电量',
          data: res.list.map((item) => item.chargeEnergy),
        },
        {
          name: '放电量',
          data: res.list.map((item) => item.dischargeEnergy),
        },
        {
          name: '负载功率',
          data: res.list.map((item) => item.loadPower),
        },
        {
          name: '光伏PV发电量',
          data: res.list.map((item) => item.chargeEnergyPV),
        },
        {
          name: '储能柜馈网电量',
          data: res.list.map((item) => item.feedbackGridEnergy),
        },
        {
          name: '光伏馈网电量',
          data: res.list.map((item) => item.feedbackGridEnergyPV),
        },
      ],
    }
  })
}

watch(energyAnalysisCycle, () => {
  fetchEssEnergyAnalysisStats()
})
onMounted(() => {
  fetchEssEnergyAnalysisStats()
  startIntervalFlowData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, {
      gutter: 20,
      type: "flex",
      class: "evse-info"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _hoisted_5,
                    _createElementVNode("div", null, [
                      _hoisted_6,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(stationInfoData)?.todaysGenEnergy?.toFixed(0) || 0), 1),
                        _hoisted_8
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(stationInfoData)?.totalGenEnergy?.toFixed(0) || 0), 1),
                        _hoisted_10
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _hoisted_14,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(stationInfoData)?.todaysLoadUseEnergy?.toFixed(0) || 0), 1),
                        _hoisted_16
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_17,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(stationInfoData)?.totalLoadUseEnergy?.toFixed(0) || 0), 1),
                        _hoisted_19
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", null, [
                      _hoisted_24,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(stationInfoData)?.todaysChargeEnergy?.toFixed(0) || 0), 1),
                        _hoisted_26
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(stationInfoData)?.totalChargeEnergy?.toFixed(0) || 0), 1),
                        _hoisted_28
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_29,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(stationInfoData)?.todaysDischargeEnergy?.toFixed(0) || 0), 1),
                        _hoisted_31
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(stationInfoData)?.totalDischargeEnergy?.toFixed(0) || 0), 1),
                        _hoisted_33
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_34,
    _createVNode(_component_el_card, {
      class: "canvas-container",
      shadow: "hover"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "hover",
                  class: "station-info"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35,
                    _createElementVNode("div", null, [
                      _hoisted_36,
                      _createTextVNode(" " + _toDisplayString(__props.stationInfo?.address), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_37,
                      _createTextVNode(" " + _toDisplayString(__props.stationInfo?.contactName), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_38,
                      _createTextVNode(" " + _toDisplayString(__props.stationInfo?.id), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_39,
                      _createTextVNode(" " + _toDisplayString(__props.stationInfo?.essExInfo?.totalCapacity) + "kWp", 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }),
            _createVNode(_component_el_col, { span: 14 }, {
              default: _withCtx(() => [
                _createVNode(EnergyFlowCanvas, {
                  info: _unref(essStationFlowData),
                  "text-color": "#000"
                }, null, 8, ["info"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_40,
    _createVNode(_component_el_card, {
      class: "chart-container",
      shadow: "hover"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_el_radio_group, {
            modelValue: energyAnalysisCycle.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((energyAnalysisCycle).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cycleList, (cycle) => {
                return _createVNode(_component_el_radio_button, {
                  key: cycle.label,
                  label: cycle.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cycle.label), 1)
                  ]),
                  _: 2
                }, 1032, ["label"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createVNode(EnergyAnalysisChartLine, { data: essEnergyAnalysisStatsChartData.value }, null, 8, ["data"])
        ])
      ]),
      _: 1
    }),
    _hoisted_43,
    _createVNode(_component_el_card, {
      shadow: "hover",
      class: "energy-container"
    }, {
      default: _withCtx(() => [
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(essEnergyConversionStats).dailyReduceCarbon), 1),
          _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(essEnergyConversionStats).dailyPlantingTrees), 1),
          _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(essEnergyConversionStats).dailyReduceCoal), 1)
        ]),
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(essEnergyConversionStats).cumulativeReduceCarbon), 1),
          _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(essEnergyConversionStats).equivalentPlantingTrees), 1),
          _createElementVNode("div", _hoisted_54, _toDisplayString(_unref(essEnergyConversionStats).cumulativeReduceCoal), 1)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})